import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login.component';
import { AppAuthGuard } from './app.authguard';

const routes: Routes = [ 
  { path: 'login', component: LoginComponent },
  { path: '', component: AppComponent, canActivate: [AppAuthGuard] },
  { path: '**', component: AppComponent, canActivate: [AppAuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class AppRoutingModule {}